//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import _ from 'lodash';

const basePath = [
    'externalUnits',
];

export const selectExternalUnits = (state) => {
    return _.get(state, [...basePath, 'units']);
};

export const selectExternalUnitInEdit = (state) => {
    return _.get(state, [...basePath, 'unitInEdit']);
};

export default selectExternalUnits;
